




















































































































































import { Component, Prop, Inject, Watch, Vue } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import UloadCroppingPictures from "@/components/app/images/upload-cropping-pictures.vue";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import GalleryFormatForm from "@/components/forms/gallery/gallery-format-form.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import BSwitch from "../../app/switchs/b-switch.vue";
import axios from "@/api/AuthAPI/auth-request-api";

import { gallerys } from "@/config/host.config";
import { ILocale } from "@/@types/locale";
import {
  IGalleryParam,
  IPhotoFormat,
  IGallery,
} from "@/@types/gallsery/gallery";
import { AxiosResponse } from "axios";

@Component({
  components: {
    SubmitResetButtonGroop,
    "upload-img": UloadCroppingPictures,
    ChangeDeliteButtons,
    GalleryFormatForm,
    InputSearch,
    BSwitch,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class GalleryForm extends Vue {
  @Prop({ type: Object, default: null }) item!: IGallery;
  @Prop({ type: Array, default: () => [] }) formatList!: Array<IPhotoFormat>;
  @Inject("folder") readonly folder!: string;
  @Inject("foldersbg") readonly foldersbg!: string;

  activeLocale = this.$store.getters.getLanguages[0];

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  newFormat = false;

  background = "";
  poster = "";
  name = "";
  show = true;
  watermark = false;
  sort_order = 0;

  formats: Array<IGalleryParam> = [];
  names: ILocale = {};
  photos: Array<string> = [];

  search = "";

  get filteredItems(): Array<IPhotoFormat> {
    return this.formatList.filter((item) => {
      if (item.name && !Array.isArray(item.name))
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1
        );
    });
  }

  @Watch("name")
  entryFolderName(): void {
    this.names[this.activeLocale] = this.name;
  }

  @Watch("activeLocale")
  folderName(): void {
    if (this.names)
      this.name = this.names[this.activeLocale]
        ? this.names[this.activeLocale]
        : "";
    else this.name = "";
  }

  addOllForm(): void {
    for (const format of this.formatList) {
      this.addFormat(format);
    }
  }

  addFormat(format: IPhotoFormat): void {
    for (const f of this.formats) {
      if (f._id == format._id) {
        return;
      }
    }

    const newFormat: IPhotoFormat = {
      _id: format._id,
      name: format.name,
      coast: format.coast,
      show: format.show,
    };
    this.formats.push(newFormat);
  }

  onSubmitFolder(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      console.log("invalid");
      return;
    }
    const folder: IGallery = {
      _id: this.item ? this.item._id : undefined,
      name: this.names,
      show: this.show,
      watermark: this.watermark,
      sort_order: this.sort_order,
      src: {
        bg: this.background,
        poster: this.poster,
      },
      params: this.formats,
      photos: this.photos,
    };
    this.$emit("updateFolder", folder);
  }

  onReset(): void {
    this.background = "";
    this.name = "";
    this.formats = [];
  }

  async changeFormat(data: IPhotoFormat): Promise<void> {
    let uri = gallerys.formats;

    try {
      const res: AxiosResponse<IPhotoFormat> = await axios.post(uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.newFormat = false;
        this.$emit("createFormats", res.data);
        this.formats.push({
          _id: res.data._id,
          name: res.data.name,
          coast: res.data.coast,
        });
      }
    } catch (error) {
      this.newFormat = false;
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  @Watch("item")
  startChange(): void {
    if (!this.item) return;
    this.background = this.item.src.bg;
    this.sort_order = this.item.sort_order;
    this.poster = this.item.src ? this.item.src.poster : "";
    this.names = Object.assign({}, this.item.name);
    this.show = this.item.show;
    this.folderName();
    this.photos = this.item.photos;
    this.watermark = this.item.watermark;
    this.formats = this.item.params;
  }

  mounted(): void {
    this.startChange();
  }
}
